const apiUrl = process.env.API_URL || process.env.NEXT_PUBLIC_API_URL;

export default `${apiUrl}/api`;
export const gqlUrl = `${apiUrl}/graphql`;
